import React from "react";
import Button from "./index";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconButton = React.forwardRef(({ buttonSize = "md", children = null, icon, size = "sm", iconClassName = "", ...rest }, ref) => {
    return (
        <Button ref={ref} size={buttonSize} {...rest}>
            <FontAwesomeIcon className={classNames(iconClassName, { 'me-1': children })} icon={icon} size={size} />
            <span>{children}</span>
        </Button>
    )
});

export default IconButton;